import clsx from "clsx";
import { useDispatch } from "react-redux";
import { Divider, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { OUTER, SECTOR, POSTCODE } from "../../../consts/layers";
import { palette } from "../../../theme/palette";

import { View } from "../../View";
import { BaseSummaryPopover } from "../Base/BaseSummaryPopover";
import { searchHandler } from "../../../reducers/ownApp/thunkActions";

const useStyles = makeStyles(() => ({
  postcodeLine: {
    fontWeight: "bold",
    color: palette.typography.black.solid,
  },
  postcode: {
    textDecorationLine: "underline",
    cursor: "pointer",
  },
  row: {
    display: "flex",
    lineHeight: "30px",
  },
  left: {
    flex: 1,
  },
  divider: {
    height: "1px",
    background: palette.typography.black.neutral,
  },
}));

const SingleWavePopover = ({ singleWaveAreas, open, anchorEl, onClose }) => {
  const styles = useStyles();
  const dispatch = useDispatch();

  const goToPostcode = ({ outer, sector, postcode }) => {
    let type = OUTER;
    let value = outer;

    if (postcode) {
      type = POSTCODE;
      value = postcode;
    } else if (sector) {
      type = SECTOR;
      value = sector;
    }

    onClose();
    dispatch(
      searchHandler({
        item: {
          type,
          value,
        },
        type: POSTCODE,
      })
    );
  };

  return (
    <BaseSummaryPopover
      id={"singleWavePopover"}
      title={"Single Wave Areas"}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      width={"160px"}
    >
      {singleWaveAreas.map(({ outer, sector, postcode }) => (
        <View key={postcode || sector || outer}>
          <View className={clsx(styles.row, styles.postcodeLine)}>
            <View className={styles.left}>
              <Typography
                className={styles.postcode}
                onClick={() => goToPostcode({ outer, sector, postcode })}
              >
                {postcode || sector || outer}
              </Typography>
            </View>
          </View>
          <Divider className={styles.divider} />
        </View>
      ))}
    </BaseSummaryPopover>
  );
};

export default SingleWavePopover;
